import api from '../../helpers/axios'

export const state = {
    sms: null,
    smsList: []
};

export const getters = {
    sms: (state) => state.sms,
    smsList: (state) => state.smsList
};

export const mutations = {
    setSmsTemplate(state, newValue) {
        state.sms = newValue;
    },
    setSmsTemplates(state, newValue) {
        state.smsList = newValue;
    },
};

export const actions = {
    sendSms(_,  data) {
        return new Promise((resolve) => {
            api.post("/sms", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchSendSmsList({ commit },  {page, limit, search}) {
        let query = "?";
        if (search) {
            query += `phone=${search}&`;
        }
        query += `page=${page}&`;
        query += `limit=${limit}&`;
        return new Promise((resolve) => {
            api.get("/sms"+query).then((res) => {
                commit("setSmsTemplates", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
